import { cn, Icon } from "@cca/components";

export type ToggleSidebarButtonProps = {
  collapsed: boolean;
  onToggle: () => void;
};

const ToggleSidebarButton = ({
  collapsed,
  onToggle,
}: ToggleSidebarButtonProps) => (
  <button
    aria-expanded={!collapsed}
    aria-label={collapsed ? "Expand left side menu" : "Collapse left side menu"}
    className={cn(
      "absolute top-10 right-0 z-20 hidden aspect-square w-6 translate-x-1/2 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-700 duration-300 hover:bg-gray-50 hover:text-gray-700 lg:flex",
      { "rotate-180": !collapsed },
    )}
    onClick={onToggle}
  >
    <Icon type="chevron-right" />
  </button>
);

export default ToggleSidebarButton;
